import CommissionStatusButton from './CommissionStatusButton';
import CommissionStatusButtonContainer from './CommissionStatusButton.container';
export default CommissionStatusButtonContainer(CommissionStatusButton);

//# sourceMappingURL=index.js.map